import type { MaskAnnotationState } from "@shared/lib/history-types"

interface FindStoredMaskByInstanceParams {
  masks: MaskAnnotationState[]
  annotationId: string
  projectModuleId: string
  seriesId: string
}

export function findStoredMaskByInstance(params: FindStoredMaskByInstanceParams): MaskAnnotationState | undefined {
  const { masks, annotationId, projectModuleId, seriesId } = params
  return masks.find((mask) => {
    if (mask.id !== annotationId) return false
    if (mask.projectModuleId !== projectModuleId) return false
    if (mask.seriesId !== seriesId) return false
    return true
  })
}
